import { render, staticRenderFns } from "./patient-info-module-new.vue?vue&type=template&id=70d0d37c&scoped=true&"
import script from "./patient-info-module-new.vue?vue&type=script&lang=js&"
export * from "./patient-info-module-new.vue?vue&type=script&lang=js&"
import style0 from "./patient-info-module-new.vue?vue&type=style&index=0&id=70d0d37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0d37c",
  null
  
)

component.options.__file = "patient-info-module-new.vue"
export default component.exports